export default __webpack_public_path__ + "static/eth-global-prague-fcec3b84862a03a23dd16cc4cd110d54.png";